import { action, Action, Thunk, thunk } from 'easy-peasy';
import { cloneDeep } from 'lodash';
import { PosterType } from '@meitu/saas-editor-core/es/version-types';
import { editor } from '@/instance';
import { FetchTemplateDetailDetailType } from '@/types';

export interface RecordInfo {
    /** 数据类型 */
    fetchType?: FetchTemplateDetailDetailType;
    id?: number;
    material_id?: number;
    category_id?: number;
    threshold?: number;
    /** 作图记录保存时间 */
    updated_at?: number;
    /** 用于获取分享信息 */
    shareOtherId?: number;
    /** 分享的作图记录作者 */
    share_author?: number;
    /** 分享key (分享目录下的作图记录不一定有share_key, 但is_shared一定为true) */
    share_key?: string | null;
    /** 是否可以创建分享 */
    noCreateSharePermission?: boolean;
    /** 是否被分享 */
    is_shared?: boolean;
    /** 文件保存的文件夹路径 */
    current_node?: string;
    /** 是否不可复制 (创建副本) */
    copyIsDisabled?: boolean;
}

export interface IRecordType {
    destroy: Action<IRecordType>;
    recordInfo: RecordInfo;
    setRecordInfo: Action<IRecordType, RecordInfo>;
    getRecordInfo: Thunk<IRecordType, undefined, any, {}, RecordInfo>;

    /** 海报保存类型 */
    posterType: PosterType;
    setPosterType: Action<IRecordType, PosterType>;
    getPosterType: Thunk<IRecordType>;

    recentId: undefined | number;
    setRecentId: Action<IRecordType, undefined | number>;
}

const defaultRecordInfo = {
    fetchType: FetchTemplateDetailDetailType.TYPE_TEMPLATE,
    id: undefined,
    material_id: 0,
    category_id: undefined, // 分类ID
    threshold: 0, //模板门槛
    updated_at: undefined,
    share_author: undefined,
    share_key: undefined,
    current_node: undefined,
    copyIsDisabled: false,
};

// 用户记录信息
export const recordModel: IRecordType = {
    destroy: action((state) => {
        state.recordInfo = cloneDeep(defaultRecordInfo);
        state.posterType = PosterType.Poster;
    }),
    posterType: PosterType.Poster,
    setPosterType: action((state, payload) => {
        state.posterType = payload;
        editor.setPosterType(payload);
    }),
    getPosterType: thunk((action, payload, helper) => {
        return helper.getState().posterType;
    }),

    recordInfo: cloneDeep(defaultRecordInfo),
    setRecordInfo: action((state, info) => {
        state.recordInfo = { ...state.recordInfo, ...info };
    }),
    getRecordInfo: thunk((action, payload, helper) => {
        return cloneDeep(helper.getState().recordInfo);
    }),
    recentId: undefined,
    setRecentId: action((state, payload) => {
        state.recentId = payload;
    }),
};
